/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Deactivate_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not deactivate this member." |
*
* @param {Members_Deactivate_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_deactivate_error = /** @type {((inputs?: Members_Deactivate_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Deactivate_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Mitglied konnte nicht deaktiviert werden.")
	return /** @type {LocalizedString} */ ("Could not deactivate this member.")
});